import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material'

import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  tabWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',

      gap: '15px',
      maxWidth: 1048,

      [theme.breakpoints.up('tablet')]: {
        padding: SPACES.xs,
      },
    },
  },

  //* Plans
  mainPlanWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  plansWrapper: {
    display: 'flex',
    gap: '30px',
    flexWrap: 'wrap',
  },
  planIcon: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
  },
  iconWrapper: {
    height: 30,
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    fontSize: 14,
    fontWeight: '600',
    textTransform: 'uppercase',
    marginBottom: 10,
  },
  planWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,

    [theme.breakpoints.down('tablet')]: {
      gap: SPACES.xs,
    },

    [theme.breakpoints.up('tablet')]: {
      padding: 'auto',
      width: 234,

      alignItems: 'center',
      gap: '15px',
    },
  },
  planContentWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  planWrapperActive: {
    '&&': {
      border: `2px solid ${theme.palette.custom.primary}`,
    },
  },

  popularChoice: {
    '&&': {
      border: `1px dashed ${theme.palette.custom.primary}`,
    },
    [theme.breakpoints.down('tablet')]: {
      padding: `${SPACES.xs} ${SPACES.xxl} ${SPACES.xxl} ${SPACES.xxl}`,
      borderRadius: 10,
    },

    [theme.breakpoints.up('tablet')]: {
      padding: `30px 42px`,
      borderRadius: 15,
    },
  },
  planUpper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: SPACES.m,
  },
  planPriceWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  feeWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  calculationText: {
    fontWeight: FONTS.WEIGHTS.light,
    fontSize: FONTS.SIZES.xs,
    lineHeight: 1.22,
  },
  discountText: {
    marginTop: SPACES.xxs,

    fontWeight: FONTS.WEIGHTS.light,
    fontSize: FONTS.SIZES.s,
    lineHeight: 1.22,
  },
  planTitle: {
    display: 'inline-block',
    position: 'relative',
    textTransform: 'capitalize',

    margin: 0,

    fontWeight: FONTS.WEIGHTS.bold,
    fontSize: FONTS.SIZES.xxxxl,
    lineHeight: 1.39,

    textAlign: 'center',

    color: theme.palette.custom.darkBlue2,
  },
  planPricesWrapper: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.xl,
  },
  planPriceTitle: {
    marginBottom: `0.25rem !important`,
    border: `0.5px solid ${theme.palette.custom.grey2}`,
    borderRadius: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    padding: '3px 9px',
    '&&': {
      fontSize: FONTS.SIZES.s,

      color: theme.palette.custom.grey2,
    },
  },
  planPrice: {
    fontSize: FONTS.SIZES.xl,
    lineHeight: 1.39,

    color: theme.palette.custom.darkBlue2,
  },
  planDescriptionList: {
    margin: 0,
    padding: 0,

    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    // gap: SPACES.xxxs,

    listStyle: 'none',
    textAlign: 'center',

    '& > li:not(:last-child)': {
      borderBottom: `1px solid ${theme.palette.custom.grey}`,
      paddingBottom: `${SPACES.xxs}`,
      marginBottom: `${SPACES.xxs}`,
    },
  },
  planDescriptionText: {
    margin: 0,

    fontSize: FONTS.SIZES.xs,
    lineHeight: 1.4,

    color: theme.palette.custom.grey2,
  },
  planButton: {
    '&&': {
      marginTop: 'auto',
      borderRadius: '10px',

      fontSize: FONTS.SIZES.s,
      textTransform: 'none',
      fontWeight: FONTS.WEIGHTS.bold,

      '&:disabled': {
        backgroundColor: theme.palette.custom.secondary,
        color: theme.palette.custom.darkBlue2,
      },

      height: 40,

      [theme.breakpoints.down('tablet')]: {
        width: 100,
      },
      [theme.breakpoints.up('tablet')]: {
        width: 150,
      },
    },
  },

  //* Common
  itemBorder: {
    border: `1px solid ${theme.palette.custom.grey}`,
    [theme.breakpoints.down('tablet')]: {
      padding: `${SPACES.xs} ${SPACES.xxl} ${SPACES.xxl} ${SPACES.xxl}`,
      borderRadius: 10,
    },

    [theme.breakpoints.up('tablet')]: {
      padding: `30px 42px`,
      borderRadius: 15,
    },
  },
  itemTitle: {
    margin: 0,

    [theme.breakpoints.down('tablet')]: {
      fontWeight: FONTS.WEIGHTS.light,
      fontSize: FONTS.SIZES.s,

      lineHeight: 1.33,
      color: theme.palette.custom.grey2,
    },
    [theme.breakpoints.up('tablet')]: {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.xl,
      lineHeight: 1.4,

      color: theme.palette.custom.darkBlue2,
    },
  },
}))

export { useStyles }
